import React from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
import { FileText, ShoppingCart, Truck, CreditCard, Shield } from 'lucide-react';

export const AGB = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <div className="pt-32 pb-20">
        <div className="container mx-auto px-4 max-w-4xl">
          <div className="mb-12">
            <span className="inline-block px-4 py-2 rounded-full bg-[#8B1538]/10 text-[#8B1538] text-sm font-semibold mb-4">
              Rechtliches
            </span>
            <h1 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
              Allgemeine Geschäftsbedingungen (AGB)
            </h1>
            <p className="text-lg text-gray-600">
              Für den Handel mit Baustoffen
            </p>
          </div>

          <div className="bg-white rounded-2xl shadow-lg border border-gray-200 p-8 lg:p-12 space-y-8">
            {/* Geltungsbereich */}
            <div>
              <div className="flex items-center mb-4">
                <FileText className="w-6 h-6 text-[#8B1538] mr-3" />
                <h2 className="text-2xl font-bold text-gray-900">1. Geltungsbereich</h2>
              </div>
              <div className="ml-9 text-gray-700 leading-relaxed space-y-3">
                <p>
                  Diese Allgemeinen Geschäftsbedingungen (AGB) gelten für alle Geschäftsbeziehungen zwischen Kalem Baustoffhandel, Enes Cuhadar, Waldseestr. 46, 63486 Bruchköbel (nachfolgend „Verkäufer“) und seinen Kunden (nachfolgend „Käufer“).
                </p>
                <p>
                  Die AGB gelten ausschließlich. Abweichende, entgegenstehende oder ergänzende AGB des Käufers werden nur dann und insoweit Vertragsbestandteil, als der Verkäufer ihrer Geltung ausdrücklich schriftlich zugestimmt hat.
                </p>
                <p>
                  Diese AGB gelten auch für alle zukünftigen Geschäfte mit dem Käufer, soweit es sich um Rechtsgeschäfte verwandter Art handelt.
                </p>
              </div>
            </div>

            {/* Vertragsschluss */}
            <div className="border-t border-gray-200 pt-8">
              <div className="flex items-center mb-4">
                <ShoppingCart className="w-6 h-6 text-[#8B1538] mr-3" />
                <h2 className="text-2xl font-bold text-gray-900">2. Vertragsschluss</h2>
              </div>
              <div className="ml-9 text-gray-700 leading-relaxed space-y-3">
                <p>
                  Angebote des Verkäufers sind freibleibend und unverbindlich, sofern nicht ausdrücklich als verbindlich gekennzeichnet.
                </p>
                <p>
                  Die Bestellung des Käufers gilt als verbindliches Vertragsangebot. Der Verkäufer kann dieses Angebot innerhalb von 7 Tagen annehmen.
                </p>
                <p>
                  Die Annahme erfolgt entweder durch schriftliche Auftragsbestätigung oder durch Lieferung der Ware.
                </p>
                <p>
                  Alle angegebenen Preise sind Nettopreise zuzüglich der gesetzlichen Mehrwertsteuer.
                </p>
              </div>
            </div>

            {/* Preise und Zahlung */}
            <div className="border-t border-gray-200 pt-8">
              <div className="flex items-center mb-4">
                <CreditCard className="w-6 h-6 text-[#8B1538] mr-3" />
                <h2 className="text-2xl font-bold text-gray-900">3. Preise und Zahlungsbedingungen</h2>
              </div>
              <div className="ml-9 text-gray-700 leading-relaxed space-y-3">
                <p>
                  Es gelten die am Tag der Bestellung gültigen Preise. Alle Preise verstehen sich ab Lager zuzüglich Verpackung, Versandkosten und der gesetzlichen Mehrwertsteuer.
                </p>
                <p>
                  Rechnungen sind, sofern nichts anderes vereinbart wurde, innerhalb von 14 Tagen nach Rechnungsdatum ohne Abzug zu zahlen.
                </p>
                <p>
                  Bei Zahlungsverzug sind wir berechtigt, Verzugszinsen in Höhe von 9 Prozentpunkten über dem Basiszinssatz zu berechnen. Die Geltendmachung eines höheren Verzugsschadens bleibt vorbehalten.
                </p>
                <p>
                  Der Käufer hat ein Recht zur Aufrechnung nur, wenn seine Gegenanspruch rechtskräftig festgestellt, unbestritten oder vom Verkäufer anerkannt ist.
                </p>
              </div>
            </div>

            {/* Lieferung und Lieferzeit */}
            <div className="border-t border-gray-200 pt-8">
              <div className="flex items-center mb-4">
                <Truck className="w-6 h-6 text-[#8B1538] mr-3" />
                <h2 className="text-2xl font-bold text-gray-900">4. Lieferung und Lieferzeit</h2>
              </div>
              <div className="ml-9 text-gray-700 leading-relaxed space-y-3">
                <p>
                  Die Lieferung erfolgt deutschlandweit. Die Lieferzeit beträgt, sofern nichts anderes vereinbart wurde, in der Regel 3-5 Werktage nach Vertragsschluss.
                </p>
                <p>
                  Die Lieferfrist beginnt mit dem Datum der Auftragsbestätigung, jedoch nicht vor Klärung aller Einzelheiten der Auftragsabwicklung.
                </p>
                <p>
                  Bei Lieferverzögerungen durch höhere Gewalt oder sonstige zum Zeitpunkt des Vertragsschlusses nicht vorhersehbare Ereignisse verlängert sich die Lieferfrist angemessen.
                </p>
                <p>
                  Die Gefahr geht mit der Übergabe der Ware an den Spediteur oder Frachtführer, spätestens mit Verlassen des Lagers auf den Käufer über.
                </p>
              </div>
            </div>

            {/* Gewährleistung */}
            <div className="border-t border-gray-200 pt-8">
              <div className="flex items-center mb-4">
                <Shield className="w-6 h-6 text-[#8B1538] mr-3" />
                <h2 className="text-2xl font-bold text-gray-900">5. Gewährleistung und Mängelrüge</h2>
              </div>
              <div className="ml-9 text-gray-700 leading-relaxed space-y-3">
                <p>
                  Der Käufer hat die Ware unverzüglich nach Ablieferung auf Vollständigkeit, richtige Ausführung und Mängelfreiheit zu untersuchen.
                </p>
                <p>
                  Offensichtliche Mängel sind innerhalb von 7 Tagen nach Erhalt der Ware schriftlich zu rügen. Versteckte Mängel sind unverzüglich nach Entdeckung schriftlich zu rügen.
                </p>
                <p>
                  Bei berechtigter Mängelrüge haben wir das Recht, nach unserer Wahl nachzubessern oder Ersatz zu liefern. Schlägt die Nachbesserung oder Ersatzlieferung fehl, kann der Käufer nach seiner Wahl Minderung verlangen oder vom Vertrag zurücktreten.
                </p>
                <p>
                  Die Gewährleistungsfrist beträgt 12 Monate ab Lieferung der Ware.
                </p>
              </div>
            </div>

            {/* Haftung */}
            <div className="border-t border-gray-200 pt-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">6. Haftung</h2>
              <div className="text-gray-700 leading-relaxed space-y-3">
                <p>
                  Schadensersatzansprüche des Käufers sind ausgeschlossen, soweit sich aus den nachfolgenden Bestimmungen nichts anderes ergibt.
                </p>
                <p>
                  Der vorstehende Haftungsausschluss gilt nicht für Schadensersatzansprüche aus der Verletzung des Lebens, des Körpers, der Gesundheit oder aus der Verletzung wesentlicher Vertragspflichten sowie für Schadensersatzansprüche aus der Verletzung von Pflichten, deren Erfüllung die ordnungsgemäße Durchführung des Vertrags überhaupt erst ermöglicht und auf deren Einhaltung der Käufer regelmäßig vertrauen darf.
                </p>
                <p>
                  Der Haftungsausschluss gilt ferner nicht für Ansprüche, die auf einer vorsätzlichen oder grob fahrlässigen Pflichtverletzung des Verkäufers, seiner gesetzlichen Vertreter oder Erfüllungsgehilfen beruhen.
                </p>
              </div>
            </div>

            {/* Eigentumsvorbehalt */}
            <div className="border-t border-gray-200 pt-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">7. Eigentumsvorbehalt</h2>
              <div className="text-gray-700 leading-relaxed space-y-3">
                <p>
                  Die gelieferte Ware bleibt bis zur vollständigen Bezahlung des Kaufpreises unser Eigentum.
                </p>
                <p>
                  Der Käufer ist verpflichtet, die Vorbehaltsware pfleglich zu behandeln und auf eigene Kosten gegen Feuer-, Wasser- und Diebstahlschäden ausreichend zu versichern.
                </p>
              </div>
            </div>

            {/* Datenschutz */}
            <div className="border-t border-gray-200 pt-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">8. Datenschutz</h2>
              <div className="text-gray-700 leading-relaxed">
                <p>
                  Der Verkäufer verarbeitet personenbezogene Daten des Käufers gemäß den Bestimmungen der Datenschutzgrundverordnung (DSGVO). Nähere Informationen finden Sie in unserer Datenschutzerklärung.
                </p>
              </div>
            </div>

            {/* Schlussbestimmungen */}
            <div className="border-t border-gray-200 pt-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">9. Schlussbestimmungen</h2>
              <div className="text-gray-700 leading-relaxed space-y-3">
                <p>
                  Es gilt das Recht der Bundesrepublik Deutschland unter Ausschluss des UN-Kaufrechts.
                </p>
                <p>
                  Erfüllungsort und ausschließlicher Gerichtsstand für alle Streitigkeiten aus diesem Vertrag ist der Geschäftssitz des Verkäufers, sofern der Käufer Kaufmann, juristische Person des öffentlichen Rechts oder öffentlich-rechtliches Sondervermögen ist.
                </p>
                <p>
                  Sollten einzelne Bestimmungen dieser AGB unwirksam sein oder werden, so wird die Wirksamkeit der übrigen Bestimmungen davon nicht berührt.
                </p>
              </div>
            </div>

            {/* Stand */}
            <div className="border-t border-gray-200 pt-8">
              <p className="text-sm text-gray-500">
                Stand dieser AGB: Dezember 2024
              </p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};